import {
  emailSchema,
  gstNumberSchema,
  phoneNumberSchema,
  websiteUrlSchema,
} from "utils/schemas";
import * as Yup from "yup";
import { ClientType } from "features/Clients/constants/client-organization.constants";

function contactRowMeaningful(row: unknown): boolean {
  if (!row || typeof row !== "object") return false;
  const r = row as Record<string, unknown>;
  const keys = ["firstName", "lastName", "email", "phone", "designation"];
  return keys.some((k) => String(r[k] ?? "").trim() !== "");
}

const contactRowSchema = Yup.object({
  id: Yup.number().nullable().optional(),
  firstName: Yup.string().nullable().optional(),
  lastName: Yup.string().nullable().optional(),
  email: emailSchema
    .nullable()
    .optional()
    .transform((v) => (v === "" || v == null ? undefined : v)),
  phone: phoneNumberSchema
    .nullable()
    .optional()
    .transform((v) => (v === "" || v == null ? undefined : v)),
  designation: Yup.string().nullable().optional(),
  isPrimary: Yup.boolean().optional(),
});

const schema = Yup.object({
  name: Yup.string()
    .trim()
    .min(3, "Name must be at least 3 characters")
    .matches(/^[A-Za-z0-9 ]+$/, "Name may only contain letters, numbers, and spaces")
    .required("The name field is required"),

  type: Yup.string()
    .oneOf(Object.values(ClientType) as string[], "Invalid client type")
    .required("Client type is required"),

  sectorId: Yup.mixed<number | string | "">()
    .nullable()
    .optional()
    .test(
      "sector-id",
      "Select a valid sector",
      (v) =>
        v === "" || v == null || (Number.isFinite(Number(v)) && Number(v) > 0),
    ),

  website: websiteUrlSchema.nullable().optional(),
  gstNumber: gstNumberSchema.nullable().optional(),
  panNumber: Yup.string().nullable().optional(),
  billingAddress: Yup.string().nullable().optional(),
  shippingAddress: Yup.string().nullable().optional(),

  company: Yup.string().nullable().optional(),

  address: Yup.string().required("The address field is required"),
  email: emailSchema
    .nullable()
    .optional()
    .transform((v) => (v === "" || v == null ? undefined : v)),
  phone: phoneNumberSchema
    .nullable()
    .optional()
    .transform((v) => (v === "" || v == null ? undefined : v)),
  city: Yup.string().required("The city field is required"),
  state: Yup.string().required("The state field is required"),

  contacts: Yup.array()
    .of(contactRowSchema)
    .optional()
    .test(
      "contacts-primary",
      "Mark exactly one contact as primary when contact details are filled in",
      function (rows) {
        const list = Array.isArray(rows) ? rows : [];
        const meaningful = list.filter(contactRowMeaningful);
        if (meaningful.length === 0) return true;
        const primaries = meaningful.filter((r: any) => r?.isPrimary);
        if (primaries.length !== 1) return false;
        const p = primaries[0] as Record<string, unknown>;
        if (
          String(p.firstName ?? "").trim() === "" ||
          String(p.lastName ?? "").trim() === ""
        ) {
          return this.createError({
            message:
              "Primary contact must include first and last name when contacts are used",
          });
        }
        return true;
      },
    ),

  image: Yup.mixed().nullable().optional(),
});

export default schema;
